import { isServer } from '../index'
import base64 from 'base-64'

export const encode = (value: string) => (isServer() ? base64.encode(value) : btoa(value))

export const decode = (value: string) => {
	return isServer() ? base64.decode(value) : atob(value)
}
